import { Auth0Provider } from '@auth0/auth0-react';
import React, { PropsWithChildren } from 'react';

interface Auth0ProviderWithConfigProps {
  children: React.ReactNode;
}

export const Auth0ProviderWithConfig = ({
  children
}: PropsWithChildren<Auth0ProviderWithConfigProps>): JSX.Element | null => {
  return (
    <Auth0Provider
      domain="bioplan-test-envs.eu.auth0.com"
      clientId="JGj3OaDn2UFPiFYI4sl20a8wXRKDK35U"
      authorizationParams={{ redirect_uri: window.location.origin }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      {children}
    </Auth0Provider>
  );
};
